const enabledNames = (items, nameKey = 'name') => (items ?? [])
    .filter((item) => item?.enabled !== false)
    .map((item) => item?.[nameKey])
    .filter(Boolean);

export const isShoptetAddonIntegration = (integration) => integration?.name === 'ShoptetAddon';

export function canManageIntegrationAction(integration, action) {
    if (!integration || !['pause', 'resume', 'delete'].includes(action)) return false;
    if (!isShoptetAddonIntegration(integration)) return true;
    return action === 'delete' && integration.status === 'inactive';
}

export function getIntegrationLastUpdate(integration) {
    if (!isShoptetAddonIntegration(integration)) return integration.lastRegularUpdate;
    return [integration.lastRegularUpdate, integration.lastHistoricalUpdate]
        .filter((value) => value && !Number.isNaN(new Date(value).getTime()))
        .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())[0] ?? null;
}

export function getIntegrationSourceNames(integration) {
    if (isShoptetAddonIntegration(integration)) return integration.eshopUrl ? [integration.eshopUrl] : [];
    const candidates = [
        ...enabledNames(integration.googleIntegrationCustomerClients),
        ...enabledNames(integration.metaIntegrationAdAccounts),
        ...enabledNames(integration.microsoftIntegrationCustomers),
        ...enabledNames(integration.pinterestIntegrationAdAccounts),
        ...enabledNames(integration.tikTokIntegrationAdAccounts),
        ...enabledNames(integration.criteoIntegrationAdAccounts),
        ...(integration.providerResources ?? []).map((resource) => resource?.displayName).filter(Boolean),
        ...(integration.hostNameAndApiKeyList ?? []).map((resource) => resource?.hostName).filter(Boolean),
        ...(integration.hostNameAndXmlLinkList ?? []).map((resource) => resource?.hostName).filter(Boolean),
        ...(integration.hostNameApiIdApiKeyList ?? []).map((resource) => resource?.hostName).filter(Boolean),
        ...(integration.hostNameAndTldAndApiCurrencyCodeApiKeyData ?? []).map((resource) => resource?.hostName).filter(Boolean),
    ];

    if (candidates.length === 0 && integration.domain) {
        candidates.push(integration.domain);
    }

    return [...new Set(candidates)];
}

export function getIntegrationState(integration) {
    if (isShoptetAddonIntegration(integration)) {
        return ['active', 'paused', 'inactive'].includes(integration.status) ? integration.status : 'inactive';
    }
    if (integration.paused) return 'paused';
    if (!integration.authorizationSuccessful) return 'inactive';
    return 'active';
}

export function formatIntegrationDateTime(value) {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    const pad = (number) => String(number).padStart(2, '0');
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
